import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Hidden from '@material-ui/core/Hidden';
import history from '../../core/history';
import MobileAddInsuranceController from './MobileAddInsuranceController';
import DesktopAddInsurance from './DesktopAddInsurance';
import { analyticsTrackEvent } from '../../core/analytics';
import { emptyFunction } from '../../core/util/function';
import { TOUCH_BACK, TOUCH_FRONT, TOUCH_SKIP_ALL_TOGETHER } from '../../constants';
import { getDefaultBreakpoint } from '../../core/util/device/screen';

class AddInsurance extends Component {
  static propTypes = {
    passThrough: PropTypes.string,
    clearData: PropTypes.func,
    addInsuranceFlow: PropTypes.string,
    clearEditFlow: PropTypes.func,
  };

  static defaultProps = {
    clearData: emptyFunction,
  };

  componentWillUnmount = () => {
    const { clearData } = this.props;
    /* TODO: change this so that data doesn't reset on refresh
     * Ideally, if it's a refresh don't clear the data, and if
     * it is any other page navigation like back or submit clear
     * the data. Good luck!
     */
    clearData();
  };

  handleSkip = () => {
    const { addInsuranceFlow, clearEditFlow } = this.props;
    analyticsTrackEvent(TOUCH_SKIP_ALL_TOGETHER, { addInsuranceFlow });
    clearEditFlow();
    history.push(this.props.passThrough);
  };

  handleTouch = type => () => {
    const { addInsuranceFlow } = this.props;
    analyticsTrackEvent(type, { addInsuranceFlow });
  };

  render = () => (
    <Fragment>
      <Hidden xsDown initialWidth={getDefaultBreakpoint()}>
        <DesktopAddInsurance
          handleSkip={this.handleSkip}
          onClickFront={this.handleTouch(TOUCH_FRONT)}
          onClickBack={this.handleTouch(TOUCH_BACK)}
          {...this.props}
        />
      </Hidden>
      <Hidden smUp initialWidth={getDefaultBreakpoint()}>
        <MobileAddInsuranceController
          handleSkip={this.handleSkip}
          onClickFront={this.handleTouch(TOUCH_FRONT)}
          onClickBack={this.handleTouch(TOUCH_BACK)}
          {...this.props}
        />
      </Hidden>
    </Fragment>
  );
}

export default AddInsurance;
